/* Teresa Chiuduno — comportamenti custom (header scroll + reveal on-scroll) */

(function () {
  /* Header: trasparente in cima, sfondo + ombra al primo scroll */
  var header = document.querySelector('.header-wrapper');
  if (header) {
    var updateHeader = function () {
      if (window.scrollY > 10) {
        header.classList.add('tc-scrolled');
      } else {
        header.classList.remove('tc-scrolled');
      }
    };
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* Reveal on-scroll: .tc-reveal → .is-visible quando entra in viewport */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.tc-reveal');

  if (reduced || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
  );

  revealEls.forEach(function (el) {
    observer.observe(el);
  });

  /* Carousel trascinabili con mouse (drag-to-scroll). Il touch usa lo scroll nativo. */
  /* .tc-tiles__track esclusa apposta: su desktop è una grid statica (nessuno scroll da
  trascinare) e su mobile usa lo scroll touch nativo — il drag-to-scroll qui non serve
  e il suo click-blocker (per distinguere drag da click) rompeva la navigazione delle
  card categoria, che sono semplici <a> interamente cliccabili. */
  var tracks = document.querySelectorAll('.tc-carousel__track, .tc-gift__track, .tc-social-carousel__track, .tc-reviews-real__track, .tc-peg__grid');
  tracks.forEach(function (track) {
  track.querySelectorAll('img, a').forEach(function (el) {
  el.setAttribute('draggable', 'false');
  });

  var isDown = false;
  var startX = 0;
  var startScroll = 0;
  var moved = false;
  var DRAG_THRESHOLD = 8;

  track.addEventListener('mousedown', function (e) {
  isDown = true;
  moved = false;
  startX = e.pageX;
  startScroll = track.scrollLeft;
  track.classList.add('tc-dragging');
  });

  window.addEventListener('mouseup', function () {
  if (!isDown) return;
  isDown = false;
  track.classList.remove('tc-dragging');
  track.classList.remove('tc-drag-moved');
  });

  track.addEventListener('mouseleave', function () {
  if (!isDown) return;
  isDown = false;
  track.classList.remove('tc-dragging');
  track.classList.remove('tc-drag-moved');
  });

  track.addEventListener('mousemove', function (e) {
  if (!isDown) return;
  var dx = e.pageX - startX;
  if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
  if (moved) track.classList.add('tc-drag-moved');
  track.scrollLeft = startScroll - dx;
  });

  track.addEventListener('click', function (e) {
  if (moved) {
  e.preventDefault();
  e.stopPropagation();
  }
  }, true);
  });
  /* Parallax leggero sulle sezioni campaign */
  if (!reduced) {
    var parallaxEls = [];
    document.querySelectorAll('[data-tc-parallax="true"]').forEach(function (section) {
      var target = section.querySelector('[data-tc-parallax-target]');
      if (target) parallaxEls.push({ section: section, target: target });
    });

    if (parallaxEls.length) {
      var ticking = false;
      var updateParallax = function () {
        var vh = window.innerHeight;
        parallaxEls.forEach(function (item) {
          var rect = item.section.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          var progress = (rect.top + rect.height / 2 - vh / 2) / vh; /* -0.5..0.5 circa */
          var shift = progress * -6; /* percentuale di spostamento contenuta */
          item.target.style.transform = 'translateY(' + shift + '%)';
        });
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }, { passive: true });
      updateParallax();
    }
  }
})();
